import { DateWidgetVariant } from '../../components/DateWidget';
import { Class, ClassStatus } from '../../db/classes/types';
import i18n, { i18nNS } from '../../i18n';
import { getIsDeadlineNear, getIsDeadlinePast } from '../../utils/activities';
import { formatTimeFromUnix } from '../../utils/datetime';

export function getClassStatus(status: ClassStatus | undefined) {
  return {
    isClassOpen: status === ClassStatus.OPEN,
    isClassInSession: status === ClassStatus.IN_SESSION,
    isClassClosed: status === ClassStatus.CLOSED,
    isClassNoRecord: status === ClassStatus.NO_RECORD,
    isClassCancelled: status === ClassStatus.CANCELED,
    isClassHoliday: status === ClassStatus.HOLIDAY,
  };
}

export function getClassTimingText(cls: Pick<Class, 'startTime' | 'endTime' | 'status'>) {
  const { isClassOpen, isClassInSession, isClassCancelled, isClassHoliday, isClassClosed, isClassNoRecord } =
    getClassStatus(cls.status);

  if (isClassOpen || isClassInSession || isClassClosed) {
    return `${formatTimeFromUnix(cls.startTime)} - ${formatTimeFromUnix(cls.endTime)}`;
  }

  if (isClassCancelled) return i18n.t('canceled', { ns: i18nNS.GLOSSARY });

  if (isClassHoliday) return i18n.t('holiday', { ns: i18nNS.GLOSSARY });

  if (isClassNoRecord) return i18n.t('no_record', { ns: i18nNS.COURSE });

  return '';
}

export function getClassWidgetVariant(
  cls: Pick<Class, 'startTime' | 'endTime' | 'status'>
): DateWidgetVariant {
  const { status, startTime } = cls;
  const { isClassInSession, isClassCancelled, isClassHoliday } = getClassStatus(status);

  if (isClassInSession) return 'live';

  if (isClassHoliday || isClassCancelled) return 'unpublished';

  if (getIsDeadlinePast(startTime)) {
    return 'past';
  }

  if (getIsDeadlineNear(startTime)) {
    return 'near';
  }

  return 'future';
}
